module.exports = __webpack_public_path__ + "img/west-bound.09720a1d.svg";